import Hero from '../../components/Hero/Hero';
import Features from '../../components/Features/Features';
import VideoSection from '../../components/VideoSection/VideoSection';
import Screenshots from '../../components/Screenshots/Screenshots';
import Footer from '../../components/Footer/Footer';
import Outsourcing from '../../components/Outsourcing/Outsourcing';
import Pricing from '../../components/Pricing/Pricing';
import './Home.scss';

const Home = () => {
  return (
    <main className="home">
      <Hero />
      <Features />
      <VideoSection />
      <Screenshots />
      <Pricing />
      <Outsourcing />

      <Footer />
    </main>
  );
};

export default Home;

